import { combineReducers } from 'redux';

import defaultClippingMedias from './clipping/defaultClippingMedias';

export default combineReducers({
  defaultClippingMedias,
});
